(() => {
  if (window.__lumeaSerenaBundleInstalled) return;
  window.__lumeaSerenaBundleInstalled = true;

  const sizeMap = {
    '90B': 'M',
    '90C': 'M',
    '90D': 'M',
    '95B': 'L',
    '95C': 'L',
    '95D': 'L',
    '100B': 'XL',
    '100C': 'XL',
    '100D': 'XL',
    '105B': '2XL',
    '105C': '2XL',
    '105D': '2XL',
    '105E': '2XL',
    '110B': '3XL',
    '110C': '3XL',
    '110D': '3XL',
    '110E': '3XL',
    '115B': '4XL',
    '115C': '4XL',
    '115D': '4XL',
    '115E': '4XL',
    '120B': '5XL',
    '120C': '5XL',
    '120D': '5XL',
    '120E': '5XL',
  };

  const cupOrder = ['B', 'C', 'D', 'E'];
  const backToCups = {};
  let modal;
  let previousOverflow = '';
  let previousFocus;
  let lastRecommendedSize = '';
  let applicationRun = 0;

  Object.keys(sizeMap).forEach((combination) => {
    const match = combination.match(/^(\d+)([B-E])$/);
    if (!match) return;
    const [, back, cup] = match;
    if (!backToCups[back]) backToCups[back] = [];
    backToCups[back].push(cup);
  });

  Object.values(backToCups).forEach((cups) => {
    cups.sort((a, b) => cupOrder.indexOf(a) - cupOrder.indexOf(b));
  });

  const backs = Object.keys(backToCups).sort((a, b) => Number(a) - Number(b));
  const wait = (delay) => new Promise((resolve) => window.setTimeout(resolve, delay));
  const normalize = (value) =>
    String(value || '')
      .replace(/\s+/g, '')
      .trim()
      .toLocaleUpperCase('es');

  const toAbsoluteUrl = (value) => {
    if (!value) return '';
    try {
      return new URL(value, window.location.origin).href;
    } catch (error) {
      return value;
    }
  };

  const isVisible = (element) =>
    Boolean(element && element.isConnected && element.getClientRects().length);

  const getOfferKey = (wrapper) => {
    const title = normalize(wrapper.querySelector('.moonbundle-option-title')?.textContent);
    if (title.includes('3+3')) return 'six';
    if (title.includes('2+2')) return 'four';
    return 'single';
  };

  const getActiveWrapper = () =>
    [...document.querySelectorAll('.lumea-serena-bundle .moonbundle-option-wrapper')].find(
      (wrapper) => wrapper.querySelector('.moonbundle-option-active')
    );

  const updateOfferCopy = (wrapper, offerKey) => {
    wrapper.dataset.serenaOffer = offerKey;

    const badge = wrapper.querySelector(
      '.moonbundle-option-label, .moonbundle-label-inside'
    );
    if (badge && offerKey === 'four') badge.textContent = 'AHORRAS 59,98€';
    if (badge && offerKey === 'six') badge.textContent = 'AHORRAS 89,97€';

  };

  const rulerIcon = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 17.5 17.5 4a2.1 2.1 0 0 1 3 3L7 20.5a2.1 2.1 0 0 1-3-3Z"></path>
      <path d="m13.8 7.7 2.5 2.5"></path>
      <path d="m10.8 10.7 1.7 1.7"></path>
      <path d="m7.8 13.7 2.5 2.5"></path>
    </svg>
  `;

  const addConfigHeader = (wrapper) => {
    const variantsBox = wrapper.querySelector('.moonbundle-variants-box');
    if (!variantsBox || variantsBox.querySelector('.serena-bundle-config')) return;

    const header = document.createElement('div');
    header.className = 'serena-bundle-config';
    header.innerHTML = `
      <span class="serena-bundle-config__title">Color y talla</span>
      <button class="serena-size-finder-button" type="button" aria-haspopup="dialog" data-serena-size-finder-open>
        ${rulerIcon}<span>ENCONTRAR MI TALLA</span>
      </button>
    `;
    header.querySelector('button').addEventListener('click', openModal);
    variantsBox.prepend(header);
  };

  const getVariantImagesByColor = (component) => {
    let product;
    try {
      product = JSON.parse(component.getAttribute('main-product') || '{}');
    } catch (error) {
      return new Map();
    }

    return new Map(
      (product.variants || [])
        .map((variant) => {
          const image =
            variant.featured_image?.src ||
            variant.featured_media?.preview_image?.src ||
            variant.image?.src;
          return [
            normalize(variant.option1 || variant.options?.[0]),
            toAbsoluteUrl(image),
          ];
        })
        .filter(([color, image]) => color && image)
    );
  };

  const getSelectedColor = (row) => {
    const controls = row.querySelector(
      '.moonbundle-variant-select-with-image > .moonbundle-variant-selectors'
    );
    return normalize(
      controls?.children[0]?.querySelector('.moonbundle-dropdown-selected')?.textContent
    );
  };

  const updateUnitPortraits = (wrapper, variantImagesByColor) => {
    wrapper.querySelectorAll('.moonbundle-variant-row').forEach((row) => {
      const variantSelect = row.querySelector('.moonbundle-variant-select');
      const selectorContainer = variantSelect?.querySelector(
        '.moonbundle-variant-select-with-image'
      );
      const sourceImage = selectorContainer?.querySelector(
        ':scope > img, :scope > .moonbundle-variant-image'
      );
      if (!variantSelect || !selectorContainer || !sourceImage) return;

      const unitLabel = [...variantSelect.children].find(
        (child) => child !== selectorContainer && !child.classList.contains('serena-unit-portrait')
      );
      if (!unitLabel) return;

      let portrait = variantSelect.querySelector(':scope > .serena-unit-portrait');
      if (!portrait) {
        portrait = document.createElement('img');
        portrait.className = 'serena-unit-portrait';
        portrait.alt = '';
        portrait.loading = 'lazy';
        variantSelect.insertBefore(portrait, unitLabel);
      }

      const selectedColor = getSelectedColor(row);
      const source = toAbsoluteUrl(
        variantImagesByColor.get(selectedColor) ||
          sourceImage.currentSrc ||
          sourceImage.src
      );
      if (source && portrait.src !== source) portrait.src = source;
      if (source && sourceImage.src !== source) sourceImage.src = source;
      if (selectedColor) sourceImage.alt = selectedColor;
      sourceImage.classList.add('serena-unit-image-source');
      variantSelect.classList.add('serena-unit-row');
      unitLabel.classList.add('serena-unit-number');
      selectorContainer.classList.add('serena-unit-selectors');
    });
  };

  const decorateComponent = (component) => {
    const host = component.parentElement;
    if (!host) return;

    let anchor = host.querySelector(':scope > [data-serena-bundle-anchor]');
    if (!anchor) {
      anchor = document.createElement('span');
      anchor.id = 'serena-bundle';
      anchor.dataset.serenaBundleAnchor = 'true';
      anchor.setAttribute('aria-hidden', 'true');
      anchor.style.cssText = 'display:block;height:0;scroll-margin-top:120px;';
      host.insertBefore(anchor, component);
    }

    host.classList.add('lumea-serena-bundle');

    const variantImagesByColor = getVariantImagesByColor(component);

    component.querySelectorAll('.moonbundle-option-wrapper').forEach((wrapper) => {
      const offerKey = getOfferKey(wrapper);
      wrapper.querySelectorAll('.lumea-serena-packshot').forEach((image) => image.remove());
      updateOfferCopy(wrapper, offerKey);
      addConfigHeader(wrapper);
      updateUnitPortraits(wrapper, variantImagesByColor);
    });
  };

  const getSizeButton = (row) => {
    const selectorGroups = row.querySelectorAll('.moonbundle-variant-selectors > div');
    return (
      selectorGroups[1]?.querySelector('.moonbundle-dropdown-button') ||
      row.querySelectorAll('.moonbundle-dropdown-button')[1]
    );
  };

  const getSelectedSize = (button) =>
    normalize(button?.querySelector('.moonbundle-dropdown-selected')?.textContent);

  const selectSizeInRow = async (row, size, runId) => {
    const button = getSizeButton(row);
    if (!button || !isVisible(button)) return false;
    if (getSelectedSize(button) === normalize(size)) return true;

    button.click();
    await wait(45);
    if (runId !== applicationRun) return false;

    const menus = [...document.querySelectorAll('[role="listbox"]')].filter(isVisible);
    const menu = menus[menus.length - 1];
    const option = [...(menu?.querySelectorAll('[role="option"]') || [])].find(
      (candidate) => normalize(candidate.textContent) === normalize(size)
    );

    if (!option) {
      button.click();
      return false;
    }

    option.click();
    await wait(70);
    return true;
  };

  const applySizeToActiveOffer = async (size) => {
    const runId = ++applicationRun;
    const initialWrapper = getActiveWrapper();
    const initialRows = [
      ...(initialWrapper?.querySelectorAll('.moonbundle-variant-row') || []),
    ].filter(isVisible);
    const total = initialRows.length;

    if (!total) return { applied: 0, total: 0 };

    let applied = 0;
    for (let index = 0; index < total; index += 1) {
      if (runId !== applicationRun) break;
      const currentWrapper = getActiveWrapper();
      const currentRows = [
        ...(currentWrapper?.querySelectorAll('.moonbundle-variant-row') || []),
      ].filter(isVisible);
      const row = currentRows[index];
      if (!row) continue;
      if (await selectSizeInRow(row, size, runId)) applied += 1;
    }
    return { applied, total };
  };

  const closeModal = () => {
    if (!modal?.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = previousOverflow;
    previousFocus?.focus?.();
  };

  function openModal(event) {
    event?.preventDefault();
    modal = modal || buildModal();
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    // Focusing the native select opens its picker immediately on iOS.
    modal.querySelector('.serena-size-finder__close')?.focus({ preventScroll: true });
  }

  const buildModal = () => {
    const overlay = document.createElement('div');
    overlay.className = 'serena-size-finder';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = `
      <div class="serena-size-finder__dialog" role="dialog" aria-modal="true" aria-labelledby="serena-size-finder-title">
        <button class="serena-size-finder__close" type="button" aria-label="Cerrar">&times;</button>
        <div class="serena-size-finder__heading">
          <span class="serena-size-finder__icon">${rulerIcon}</span>
          <span>
            <span class="serena-size-finder__kicker">Guía de tallas</span>
            <strong id="serena-size-finder-title">Encuentra tu talla</strong>
          </span>
        </div>
        <p class="serena-size-finder__intro">
          Indica tu talla de contorno y tu copa para descubrir la talla Serena recomendada.
        </p>
        <div class="serena-size-finder__fields">
          <label>
            <span>Contorno (ES)</span>
            <select class="serena-size-finder__back">
              <option value="">Elegir</option>
              ${backs.map((back) => `<option value="${back}">${back}</option>`).join('')}
            </select>
          </label>
          <label>
            <span>Copa</span>
            <select class="serena-size-finder__cup">
              <option value="">Elegir</option>
            </select>
          </label>
        </div>
        <div class="serena-size-finder__result" aria-live="polite">
          Elige primero tu contorno y después tu copa.
        </div>
        <p class="serena-size-finder__applied" aria-live="polite"></p>
        <p class="serena-size-finder__note">
          Si dudas entre dos tallas, elige la más pequeña para una mayor sujeción.
        </p>
        <button class="serena-size-finder__done" type="button">TERMINAR</button>
      </div>
    `;

    document.body.appendChild(overlay);
    const backSelect = overlay.querySelector('.serena-size-finder__back');
    const cupSelect = overlay.querySelector('.serena-size-finder__cup');
    const result = overlay.querySelector('.serena-size-finder__result');
    const applied = overlay.querySelector('.serena-size-finder__applied');

    const resetResult = (message) => {
      result.classList.remove('has-size');
      result.textContent = message;
      applied.textContent = '';
    };

    const computeSize = async () => {
      applied.textContent = '';
      if (!backSelect.value || !cupSelect.value) {
        resetResult('Elige tu contorno y después tu copa.');
        return;
      }

      const size = sizeMap[`${backSelect.value}${cupSelect.value}`];
      if (!size) {
        resetResult('Esta combinación no aparece en nuestra guía de tallas.');
        return;
      }

      lastRecommendedSize = size;
      result.classList.add('has-size');
      result.innerHTML = `
        <span>Tu talla Serena recomendada:</span>
        <strong>${size}</strong>
        <small>Cambio de talla gratuito si lo necesitas.</small>
      `;

      applied.textContent = 'Aplicando la talla a tu lote...';
      const outcome = await applySizeToActiveOffer(size);
      if (!outcome.total) {
        applied.textContent = `Talla recomendada: ${size}. Elige un lote para aplicarla.`;
      } else if (outcome.applied === outcome.total) {
        applied.textContent = `La talla ${size} se ha aplicado a las ${outcome.total} unidades del lote.`;
      } else {
        applied.textContent = `Talla recomendada: ${size}. Comprueba los selectores del lote.`;
      }
    };

    const refreshCups = () => {
      const previousCup = cupSelect.value;
      const cups = backToCups[backSelect.value] || [];
      cupSelect.innerHTML = '<option value="">Elegir</option>';
      cups.forEach((cup) => cupSelect.add(new Option(cup, cup)));
      if (cups.includes(previousCup)) cupSelect.value = previousCup;
      if (cupSelect.value) computeSize();
      else resetResult('Elige ahora tu copa para obtener tu talla.');
    };

    backSelect.addEventListener('change', refreshCups);
    cupSelect.addEventListener('change', computeSize);
    overlay.querySelector('.serena-size-finder__close').addEventListener('click', closeModal);
    overlay.querySelector('.serena-size-finder__done').addEventListener('click', closeModal);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closeModal();
    });
    return overlay;
  };

  let decorationFrame;
  const mount = () => {
    window.cancelAnimationFrame(decorationFrame);
    decorationFrame = window.requestAnimationFrame(() => {
      document.querySelectorAll('moonbundle-component').forEach(decorateComponent);
    });
  };

  const clearInitialBundleHash = () => {
    if (window.location.hash !== '#serena-bundle') return;

    window.history.replaceState(null, document.title, `${window.location.pathname}${window.location.search}`);
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => window.scrollTo(0, 0));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearInitialBundleHash, { once: true });
  } else {
    clearInitialBundleHash();
  }

  document.addEventListener('click', (event) => {
    const bundleScrollLink = event.target.closest('[data-serena-scroll-to-bundle]');
    if (bundleScrollLink) {
      event.preventDefault();
      const bundle = document.getElementById('serena-bundle');
      if (bundle) {
        const headerHeight = document.querySelector('.shopify-section-header')?.offsetHeight || 0;
        const top = Math.max(0, window.scrollY + bundle.getBoundingClientRect().top - headerHeight - 12);
        window.scrollTo({ top, behavior: 'smooth' });
      }
      return;
    }

    const colorOption = event.target.closest(
      '.lumea-serena-bundle [role="option"], .lumea-serena-bundle .moonbundle-dropdown-button'
    );
    if (colorOption) {
      window.setTimeout(mount, 80);
    }

    if (!lastRecommendedSize) return;
    if (!event.target.closest('.lumea-serena-bundle .moonbundle-option-details')) return;
    window.setTimeout(() => applySizeToActiveOffer(lastRecommendedSize), 240);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:block:select', mount);

  mount();
  new MutationObserver(mount).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['src'],
    childList: true,
    subtree: true,
  });
})();
